<div class="data-list-header">
    <ng-content select="app-data-filters"></ng-content>

    <ng-content select="app-data-buttons"></ng-content>
</div>

<div>
    <div class="data-list-content" infiniteScroll [infiniteScrollThrottle]="0" [infiniteScrollDistance]="0"
         [infiniteScrollDisabled]="!infiniteScroll" (scrolled)="onScroll()" [infiniteScrollContainer]="infiniteScrollContainer" [fromRoot]="true">
        <ng-template [ngTemplateOutlet]="extraActionFields" [ngTemplateOutletContext]="{ items: items }"></ng-template>

        <div class="data-list-content" *ngIf="!draggable; else draggableList">
            <ng-container *ngFor="let item of items">
                <div class="data-list-item">
                    <ng-template [ngTemplateOutlet]="itemTemplate"
                                 [ngTemplateOutletContext]="{ item: item, items: items }"></ng-template>
                </div>
            </ng-container>
        </div>
        <ng-template #draggableList>
            <div class="data-list-content" [dragula]="draggableName" [(dragulaModel)]="items">
                <ng-container *ngFor="let item of items">
                    <div class="data-list-item">
                        <ng-template [ngTemplateOutlet]="itemTemplate"
                                     [ngTemplateOutletContext]="{ item: item, items: items }"></ng-template>
                    </div>
                </ng-container>
            </div>
        </ng-template>

        <div class="data-list-footer" *ngIf="!infiniteScroll && !hidePagination">
            <app-ajax-pagination [page]="page" [pageSize]="pageSize" [lastPage]="lastPage"
                                 (pageChange)="changePage($event)"></app-ajax-pagination>
            <span class="inner-space-right-10 footer-control">
                <select [(ngModel)]="pageSize" class="form-control size-select" (change)="changePage(1)">
                    <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{size}}</option>
                </select>
                <span class="entries-count" [i18n]="[{target: 'innerHTML', key: 'data-table.count', params: {count: totalCount}}]"></span>
            </span>
        </div>
    </div>
</div>
